import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';

export function* initStatsSaga() {
  yield call([RTCClient, RTCClient.startStats]);
}
